import { useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { useSpinDelay } from "spin-delay";

import { ACCOUNTS_QUERY } from "@/apis/gql/apolloClient";
import { TabularLoading } from "@/components/shared/tabular-loading";
import { TypographySmall } from "@/components/ui/typography";
import { useTenant } from "@/providers/session";

export const CompanyInit = ({ children }: { children: React.ReactNode }) => {
  const { t } = useTranslation();
  const { tenantId } = useTenant();

  const { loading } = useQuery(ACCOUNTS_QUERY, {
    variables: { tenantId },
    skip: !tenantId,
  });

  const isLoading = useSpinDelay(loading, { delay: 600, minDuration: 0 });

  if (isLoading || !tenantId) {
    return (
      <div className="h-screen">
        <TabularLoading>
          <TypographySmall>{t("company_setup.title")}</TypographySmall>
        </TabularLoading>
      </div>
    );
  }

  return <>{children}</>;
};
